import { render, staticRenderFns } from "./IndexApp.vue?vue&type=template&id=f46dfcb6&"
import script from "./IndexApp.vue?vue&type=script&lang=js&"
export * from "./IndexApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "IndexApp.vue"
export default component.exports